import styled from "styled-components";

export const LogoStyled = styled.img`
  width: ${props => props.width || "14.84vw"};
  height: ${props => props.height || "2.1vw"};
`;
